import React from "react";
import { BellIcon } from "@heroicons/react/24/outline";
import SettingsSection from "../fields/SettingsSection";
import NotificationRow from "../fields/NotificationRow";

export default function NotificationsSection({ form, onChange }) {
  const notifications = [
    {
      key: "likes",
      label: "Likes",
      description: "When someone likes your note or comment.",
    },
    {
      key: "comments",
      label: "Comments",
      description: "New comments on your notes.",
    },
    {
      key: "system",
      label: "Notes near you",
      description: "New public notes posted within your vicinity.",
    },
  ];

  return (
    <SettingsSection
      id="notifications"
      title="Notifications"
      icon={<BellIcon className="h-5 w-5 text-primary" />}
    >
      <div className="divide-y divide-border-light">
        {notifications.map((n) => (
          <NotificationRow
            key={n.key}
            id={`notif-${n.key}`}
            label={n.label}
            description={n.description}
            checked={form.notifications[n.key]}
            onChange={(v) => onChange(`notifications.${n.key}`, v)}
          />
        ))}
      </div>
    </SettingsSection>
  );
}
